import React, {useRef, useState} from 'react'
import {makeStyles} from '@mui/styles'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {ClickAwayListener} from "@mui/material"

// Plus Minus Solution
// https://stackblitz.com/edit/react-wd5uxp?file=materialui_component%2FMyExpansionPanelComponent.jsx


const useStyles = makeStyles((theme) => ({
    root: {
        width: `100%`,
        '& .MuiCollapse-root': {
            width: `fit-content`,
            minWidth: `200px`,
            position: `absolute`,
            padding: `5px`,
            top: `110%`,
            borderRadius: `5px`,
            zIndex: 9,
            background: `#eefcfb`,
            '& .MuiAccordionDetails-root': {
                padding: `0px`,
                overflowY: `auto`
            }
        },
        '& .MuiAccordionSummary-root': {
            padding: `0 10px`,
            height: `20px`,
            'border-radius': `5px`,
            'min-height': `35px`,
            background: `#00e5c7`,
            '&.Mui-expanded': {
                'min-height': `35px`,
            }
        }
    }
}))

const SimpleAccordion = (props) => {

    const classes = useStyles()
    const [expanded, setExpanded] = useState(false)
    const [maxDetailHeight, setMaxDetailHeight] = useState(`0`)
    const detailRef = useRef()


    const closeDropDown = () => {
        setExpanded(false)
    }

    const toggleDropDown = () => {
        setExpanded(!expanded)
    }
    
    const setMaxHeight = (event, expanded) => {
        const top = detailRef.current.getBoundingClientRect().y + 32
        setMaxDetailHeight(expanded ? `calc(100vh - ${top}px)` : `0`)
    }

    return (
        <ClickAwayListener onClickAway={closeDropDown}>
            <div className={classes.root}>
            <Accordion
                elevation={0}
                square={true}
                expanded={expanded}
                onChange={setMaxHeight}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    onClick={toggleDropDown}
                >
                    <h6 className="filter-list-title weight-semi-bold">{props.title}</h6>
                </AccordionSummary>
                <AccordionDetails
                    sx={{maxHeight: maxDetailHeight, '& .wide': {maxHeight: maxDetailHeight}}}
                    ref={detailRef}
                >
                    {props.children}
                </AccordionDetails>
            </Accordion>
        </div>
        </ClickAwayListener>
    )
}

export default SimpleAccordion

